/**
 * orga-app-api - displaysteuerung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DisplaysteuerungBenutzerZugriff { 
    ist_aktiv?: boolean;
    darf_verwalten?: boolean;
    mandant_id: string;
    modified_on_utc: Date;
}

